var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_387",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50048",
    "data-name": "Path 50048",
    d: "M107.515,185.137h-5.881L88.5,183.113,92.3,182h7.041a11.806,11.806,0,0,1,6.853,2.2Z",
    transform: "translate(-88.5 -182)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29260",
    "data-name": "Group 29260",
    transform: "translate(434 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -434, -11099)",
    filter: "url(#Ellipse_387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387-2",
    "data-name": "Ellipse 387",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_12_",
    "data-name": "svgexport-17 (12)",
    transform: "translate(-417.182 -11072.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50030",
    "data-name": "Path 50030",
    d: "M36.3,172.391H32.993l-3.474-2.352A11.729,11.729,0,0,0,22.9,168H14.645L5,170.94V172h.863v3.372H5v2.666l1.372,1.8h37.05v-1.866l.941-2.141-1.811-1.357A10.381,10.381,0,0,0,36.3,172.391Z",
    transform: "translate(-5 -168)",
    fill: "#db3328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50031",
    "data-name": "Path 50031",
    d: "M12.371,182H11.046L5,183.843l1.631.039Z",
    transform: "translate(-5 -180.902)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50032",
    "data-name": "Path 50032",
    d: "M286.278,182H285.4l4.815,3.293h1.192l-3.474-2.36A9.6,9.6,0,0,0,286.278,182Z",
    transform: "translate(-263.413 -180.902)",
    fill: "#747e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50033",
    "data-name": "Path 50033",
    d: "M43.422,226.841H6.372L5,225.038H43.422Zm-35.858-4.47h-1.7V219h1.7l.823,1.921Z",
    transform: "translate(-5 -215.001)",
    fill: "#b5100b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50034",
    "data-name": "Path 50034",
    d: "M107.515,185.137h-5.881L88.5,183.113,92.3,182h7.041a11.806,11.806,0,0,1,6.853,2.2Z",
    transform: "translate(-81.953 -180.902)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50035",
    "data-name": "Path 50035",
    d: "M178.3,236.948l-12.773-.761-2.431-3.058L165.641,232l12.428,1.882a.7.7,0,0,1-.776.7l-10.719-1.215-.949.47,1.325,1.255,10.758,1.192A.665.665,0,0,1,178.3,236.948Z",
    transform: "translate(-150.703 -226.982)",
    fill: "#b5100b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50036",
    "data-name": "Path 50036",
    d: "M476,263h2.431v.784H476Z",
    transform: "translate(-439.068 -255.551)",
    fill: "#ebeadf"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 3.819,
    cy: 3.819,
    rx: 3.819,
    ry: 3.819,
    transform: "translate(3.089 6.163)",
    fill: "#323d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50037",
    "data-name": "Path 50037",
    d: "M81.8,246.545a3.63,3.63,0,0,0-.925.071.281.281,0,0,0,.063.557h.055a3.839,3.839,0,0,1,3.819,3.819v.055a.281.281,0,0,0,.557.063,3.991,3.991,0,0,0,.071-.925,3.827,3.827,0,0,0-3.638-3.638Z",
    transform: "translate(-74.716 -240.381)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50038",
    "data-name": "Path 50038",
    d: "M49.878,268.354a3.837,3.837,0,0,1-3.568-3.568v-.047a.723.723,0,0,0-1.325-.361,3.785,3.785,0,0,0-.635,2.3,3.823,3.823,0,0,0,5.936,3,.723.723,0,0,0-.361-1.325Z",
    transform: "translate(-41.261 -256.522)",
    fill: "#1c2617"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 1.874,
    cy: 1.874,
    rx: 1.874,
    ry: 1.874,
    transform: "translate(5.034 8.108)",
    fill: "#747e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50039",
    "data-name": "Path 50039",
    d: "M89.723,271.331a1.99,1.99,0,0,0-.306,0,.157.157,0,0,0,.008.314h.024a1.886,1.886,0,0,1,1.678,1.678v.023a.157.157,0,0,0,.314.008,1.991,1.991,0,0,0,0-.306A1.879,1.879,0,0,0,89.723,271.331Z",
    transform: "translate(-82.666 -263.223)",
    fill: "#c4c1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50040",
    "data-name": "Path 50040",
    d: "M71.66,284.43a1.867,1.867,0,0,1-1.647-1.647v-.024a.37.37,0,0,0-.7-.133,1.881,1.881,0,0,0,1.56,2.674,1.843,1.843,0,0,0,.933-.172.369.369,0,0,0-.133-.7Z",
    transform: "translate(-64.109 -273.453)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50041",
    "data-name": "Path 50041",
    d: "M22,219h.6v3.372H22Z",
    transform: "translate(-20.667 -215.001)",
    fill: "#e67368"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    cx: 3.819,
    cy: 3.819,
    rx: 3.819,
    ry: 3.819,
    transform: "translate(28.511 6.163)",
    fill: "#323d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50042",
    "data-name": "Path 50042",
    d: "M374.078,268.354a3.837,3.837,0,0,1-3.568-3.568v-.047a.723.723,0,0,0-1.325-.361,3.785,3.785,0,0,0-.635,2.3,3.823,3.823,0,0,0,5.936,3,.723.723,0,0,0-.361-1.325h-.047Z",
    transform: "translate(-340.039 -256.522)",
    fill: "#1c2617"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    cx: 1.874,
    cy: 1.874,
    rx: 1.874,
    ry: 1.874,
    transform: "translate(30.44 8.108)",
    fill: "#747e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50043",
    "data-name": "Path 50043",
    d: "M405.8,246.545a3.63,3.63,0,0,0-.925.071.281.281,0,0,0,.063.557h.055a3.839,3.839,0,0,1,3.819,3.819v.055a.281.281,0,0,0,.557.063,3.99,3.99,0,0,0,.071-.925A3.827,3.827,0,0,0,405.8,246.545Z",
    transform: "translate(-373.31 -240.381)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50044",
    "data-name": "Path 50044",
    d: "M413.723,271.331a1.99,1.99,0,0,0-.306,0,.157.157,0,0,0,.008.314h.024a1.886,1.886,0,0,1,1.678,1.678v.023a.157.157,0,0,0,.314.008,2,2,0,0,0,0-.306A1.879,1.879,0,0,0,413.723,271.331Z",
    transform: "translate(-381.26 -263.223)",
    fill: "#c4c1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50045",
    "data-name": "Path 50045",
    d: "M395.66,284.43a1.867,1.867,0,0,1-1.647-1.647v-.024a.37.37,0,0,0-.7-.133,1.881,1.881,0,0,0,1.56,2.674,1.843,1.843,0,0,0,.933-.172.369.369,0,0,0-.133-.7Z",
    transform: "translate(-362.703 -273.453)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50046",
    "data-name": "Path 50046",
    d: "M24.682,198.85h5.881l2.431.157h6.861a10.888,10.888,0,0,0-3.552-.627H32.993l-2.431-.157H24.682L11.54,196.2,5,196.929v.674l6.547-.533Z",
    transform: "translate(-5 -193.989)",
    fill: "#e67368"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28923",
    "data-name": "Group 28923",
    transform: "translate(6.547 1.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28922",
    "data-name": "Group 28922",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50047",
    "data-name": "Path 50047",
    d: "M138.652,178.217h-1.4L132.7,173.7h1.4Zm4.242,0h-2.933l-4.548-4.517h2.925Z",
    transform: "translate(-129.234 -174.351)",
    fill: "#747e6c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50049",
    "data-name": "Path 50049",
    d: "M176.4,184.407l-1.6-.251V182h1.6Z",
    transform: "translate(-161.485 -180.902)",
    fill: "#323d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50050",
    "data-name": "Path 50050",
    d: "M5,205.5H6.631",
    transform: "translate(-5 -202.56)",
    fill: "#485143"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.4b5259df62aa24e30a43f5230cb7059f.svg";
export { ForwardRef as ReactComponent };